import { defineComponent as _defineComponent } from 'vue'
import { ImageGroup } from "../data";
import { ImageTransform } from "../types";
import ResizeImageSize from "./ResizeImageSize.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResizeSocialGroup',
  props: {
    group: null,
    transform: null,
    image: null
  },
  setup(__props: any) {

const props = __props as {
  group: ImageGroup;
  transform: ImageTransform;
  image?: HTMLImageElement;
}



return { __sfc: true,props, ResizeImageSize }
}

})